export default {
  'Please select an output format': 'कृपया आउटपुट फॉर्मेट चुनें',
}